
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
//import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
//import Flickity from "flickity";
import Flickity from "flickity-fade";
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar.js';
import FarloUiWhatsOnCalendar from './vendors/farlo-ui-whats-on-calendar.js';
import FarloUiAccessibleCalendar from './vendors/farlo-ui-accessible-performances.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { ticker } from './components/footer/ticker.js';
import { formDates } from './components/footer/formDates.js';
import { handleNavigation } from './components/footer/handleNavigation.js';
import { expand } from './components/footer/expand.js';
//import { draggableSlider } from './components/footer/draggableSlider.js';
import { particles } from './components/footer/particles.js';
import { newsFilter, filterPosts } from './components/footer/newsFilter.js';
import { showContents } from './components/footer/showContents.js';
import { careersExpand } from './components/footer/careersExpand.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	function flickityResize(flkty) {
		flkty.slides.forEach(slide => slide.cells[0].element.style.height = '');
						
		let heights = flkty.slides.map(slide => slide.cells[0].element.offsetHeight),
			max = Math.max.apply(Math, heights);

		flkty.slides.forEach(slide => slide.cells[0].element.style.height = max + 'px');
		setTimeout(() => {
			flkty.viewport.style.height = max + "px";
		},100);
	}

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if(document.querySelector('.site-event-details__contents--show-more')){
			showContents();
		}

		// if (document.querySelector('#particles-js')){
		// 	particles();
		// }

		if (document.querySelector('.site-masthead__ticker')){
			ticker();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.site-events__slider')){
			document.querySelectorAll('.site-events__slider').forEach(_sel => {
				const elements = _sel.querySelector(".site-events__container-inner");
				if (elements) {
					var flkty = new Flickity( elements, {
						draggable:true, 
						pageDots:false,
						prevNextButtons:false, 
						wrapAround: false, 
						cellAlign:"left", 
						freeScroll : true,
						contain: true,
						adaptiveHeight: true,
						on: {
						 	ready: function() {
								//flickityResize(flkty)
							}
						
						// 		console.log("yo")
						// 	  setTimeout(function() {
						// 		_sel.querySelectorAll(".flickity-cell").forEach(_cell => {
						// 			_cell.style.height = _cell.querySelector(".site-event-card").scrollHeight + "px";
						// 		})
						// 	  },100);
						// 	},
						//   },
						//   select: function() {
						
						 }
					});
					flkty.on( 'resize', function() {
						flickityResize(this);
					});
					flkty.resize();
					setTimeout(() => {
						flkty.resize();
					},100);
				}
			});
		}
		if (document.querySelector("#svg-icons-carousel")) {
			document.querySelectorAll('#svg-icons-carousel').forEach(_sel => {
				var flkty = new Flickity( _sel, {
					draggable:true, 
					autoPlay:false, 
					pageDots:false,
					prevNextButtons:false, 
					wrapAround: false, 
					cellAlign:"left", 
					freeScroll : true,
					setGallerySize: true,
					contain: true,
					on: {
						ready: function() {
						  setTimeout(function() {
							_sel.querySelectorAll(".flickity-cell").forEach(_cell => {
								_cell.style.height = "100%";
							})
						  },100);
						}
					  }

				});

			});
		}

		if (document.querySelector('.menu-item-has-children')){
			handleNavigation();
		}

		if (document.querySelector('.site-event-details__secondary-description')) {
			expand();
		}

		if (document.querySelector('#input_1_9')){
			formDates();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			document.querySelectorAll('.farlo-ui-crm__toggle').forEach((_sel) => {
				_sel.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}

		if (document.querySelector('.location-filter')){
			//filterPosts();
			newsFilter();
		}

		if (document.querySelector('.rank-math-list-item')){
			document.querySelectorAll(".rank-math-question").forEach((_el) => {
                _el.dataset.toggled = "0";
                _el.addEventListener("click", () => {
                    toggleFAQ(_el);
                })
            });
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.careers__list-item')){
			careersExpand();
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="calendar"]')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="whats-on-calendar"]')) {
			document.querySelectorAll('[farlo-ui="whats-on-calendar"]').forEach((_sel) => {
				new FarloUiWhatsOnCalendar(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar' && '[farlo-ui="accessible-calendar"]')) {
			document.querySelectorAll('[farlo-ui="accessible-calendar"]').forEach((_sel) => {
				new FarloUiAccessibleCalendar(_sel);
			});
		}

		if (document.querySelector('form')) {
			document.querySelector('form').querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		function initializeCarousel(selector) {
			document.querySelectorAll(selector).forEach((_sel) => {
				var flkty = new Flickity( _sel, {});
			});
		}
	

		
		// function initializeSvgCarousel() {
		// 	const svgIconsCarousel = document.getElementById('svg-icons-carousel');
		// 	if (window.innerWidth < 980) {
		// 		if (svgIconsCarousel && !svgIconsCarousel.classList.contains('initialized')) {
		// 			svgIconsCarousel.classList.add('initialized');
		// 			svgIconsCarousel.carouselInstance = new FarloUiRevolverCarousel(svgIconsCarousel, {
		// 				auto: true,
		// 				autoDuration: 3000,
		// 				arrows: false,
		// 				pagination: true
		// 			});
		// 		}
		// 	} else {
		// 		if (svgIconsCarousel && svgIconsCarousel.classList.contains('initialized')) {
		// 			svgIconsCarousel.classList.remove('initialized');
		// 			if (svgIconsCarousel.carouselInstance) {
		// 				svgIconsCarousel.carouselInstance.destroy();
		// 				delete svgIconsCarousel.carouselInstance;
		// 			}
		// 		}
		// 	}
		// }
		
		// Initialize existing carousels
		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			initializeCarousel('.farlo-ui-revolver-carousel');
			
		}
		
		// Initialize SVG carousel on page load if screen size is below 980px
		//initializeSvgCarousel();
		
		// Add event listener for window resize to initialize/deinitialize SVG carousel as needed
		// window.addEventListener('resize', function() {
		// 	initializeSvgCarousel();
		// });
		
	});

	const checkInputValue = (_inp) => {
		if (_inp.value) {
			_inp.parentElement.classList.add("form-item-active");
		} else {
			_inp.parentElement.classList.remove("form-item-active");
		}
	}
	document.querySelectorAll(".form-field").forEach((_inp) => {

		_inp.addEventListener("focus",() => {
			_inp.parentElement.classList.add("form-item-active");	
		});
		_inp.addEventListener("blur", () => {
			checkInputValue(_inp);
		});
		checkInputValue(_inp);
	});

	document.querySelectorAll(".gfield input").forEach((_inp) => {
		const parentDiv = _inp.closest(".gfield");
	  
		_inp.addEventListener("focus", () => {
		  parentDiv.classList.add("form-item-active");
		});
	  
		_inp.addEventListener("blur", () => {
		  parentDiv.classList.remove("form-item-active");
		  checkInputValue(_inp);
		});
	  
		checkInputValue(_inp);
	});
	  

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}

})(document, window, history);
